
// One product row of the SOA's checkbox list (#656 comment 2, Dien's SOA
// mockups): a real checkbox per product. First built for the renewal, it now
// replaces the Yes/No/Not-sure buttons everywhere a client signs: SignStep
// (/renewal/sign and /checkup/sign) and the scheduler's SoaStep (/schedule).
// Its styles live in components/checkup/checkup.scss; the scheduler keeps a
// scoped copy in assets/scss/overrides.scss (.sv2-soa-checks), since it does
// not load checkup.scss.
export default {
    props: {
        product: { type: Object, required: true },
        value: { type: Boolean, default: false },
    },
    data () {
        return { expanded: false }
    },
    computed: {
        inputId () { return `soa-tick-${this.product.id}` },
    },
}
